import createAxiosInstance from './axiosConfig';
import { ParametrosGerais } from '../shared/model/parametrosGerais';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/parametrosgeraisController');

export default class ParametrosGeraisService {
    axios: any;

    constructor() {
        this.axios = axiosInstance;
    }

    async alterarParametrosGerais(dto: ParametrosGerais){
        return await this.axios.post(`/cadastrarParametrosGerais`, dto);
    }

    async listarTodosParametros() {
        return await this.axios.get(`/listarTodosParametrosGerais`);
    };
}